import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "status", "newStatus", "toggleButton"]

  connect() {
    this.formTarget.addEventListener("submit", (event) => {
      event.preventDefault()

      const formData = new FormData(this.formTarget)

      fetch(this.formTarget.action, {
        method: this.formTarget.method,
        headers: {
          "X-CSRF-Token": document.querySelector("[name=csrf-token]").content,
          "Accept": "application/json",
        },
        body: formData,
      })
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
          return response.json()
        })
        .then(data => {
          if (data.success) {
            const currentStatus = data.status.toUpperCase()
            this.statusTarget.textContent = currentStatus
            this.newStatusTarget.value = currentStatus === "IN" ? "out" : "in"
            this.toggleButtonTarget.textContent = currentStatus === "IN" ? "Opt-Out" : "Opt-In"
          } else {
            alert(`Failed to update SMS status: ${data.message}`)
          }
        })
        .catch(error => {
          console.error("SMS status update error:", error)
          alert("Error updating SMS status.")
        })
    })
  }
}

